import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PartnersDtoResponse } from '../dto/response-dto/partner-details-response-dto';
import { SelectionResponse } from '../dto/response-dto/configuration-selection-dto';
import { PartnerConfigurationResponseDTO } from '../dto/response-dto/partner-configuration-response-dto';
import { PartnerConfigurationRequestDTO } from '../dto/request-dto/partner-configuration-request-dto';
import { PartnerLimitRequestDTO } from '../dto/request-dto/partner-limit-request-dto';
import { ResponseDTO } from '../dto/response-dto/response-dto';

@Injectable({
    providedIn: 'root'
})
export class PartnerConfigurationService {
    public partnerId = 'PRThURb';
    public constructor(private http: HttpClient) { }

    public getPartnerDetails(): Observable<PartnersDtoResponse> {
        const url = environment.baseUrl + 'Configuration/partners?isTopconPartner=false';
        return this.http.get<PartnersDtoResponse>(url);
    }

    public getPartnerConfiguration(id : number): Observable<PartnerConfigurationResponseDTO> {
        const url = environment.baseUrl + 'PartnerConfiguration/' + id;
        return this.http.get<PartnerConfigurationResponseDTO>(url);
    }

    public postConfigurationProduct(
        data: PartnerConfigurationRequestDTO
    ): Observable<PartnerConfigurationResponseDTO> {
        const url = environment.baseUrl + 'PartnerConfiguration/productcode';
        return this.http.post<PartnerConfigurationResponseDTO>(url, data);
    }

    public updateConfiguration(
        data: PartnerConfigurationRequestDTO
    ): Observable<PartnerConfigurationResponseDTO> {
        const url = environment.baseUrl + 'PartnerConfiguration/productcode';
        return this.http.put<PartnerConfigurationResponseDTO>(url, data);
    }

    public DeleteById(id: number): Observable<ResponseDTO> {
        const url = environment.baseUrl + 'PartnerConfiguration/productcode/' + id;
        return this.http.delete(url);
    }

    public getConfigurationSelection(): Observable<SelectionResponse> {
        const url = environment.baseUrl + 'Configuration/selection?isTopconPartner=false';
        return this.http.get<SelectionResponse>(url);
    }

    public updatePartnerLimit(data: PartnerLimitRequestDTO):Observable<PartnersDtoResponse> {
        const url = environment.baseUrl + 'Configuration/partner/limit';
        return this.http.put<PartnersDtoResponse>(url, data);
    }
}
